import { createContextualCan } from '@casl/react'

import { AbilityContext } from '@/lib/auth/abilityContext'

const Can = createContextualCan(AbilityContext.Consumer)

export { Can }
